var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    { staticClass: "excelUploadBox" },
    [
      _c(
        "el-form-item",
        { attrs: { prop: "name" } },
        [
          _c("el-input", {
            model: {
              value: _vm.name,
              callback: function ($$v) {
                _vm.name = $$v
              },
              expression: "name",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        [
          _c(
            "el-upload",
            {
              ref: "upfile",
              staticStyle: { display: "inline" },
              attrs: {
                "before-upload": _vm.beforeUpload,
                "auto-upload": false,
                "on-change": _vm.handleChange,
                "on-error": _vm.uploadError,
                limit: 1,
                action: "#",
                accept: _vm.accept,
              },
            },
            [
              _c("el-button", { staticClass: "chooseFile" }, [
                _vm._v("请选择导入文件"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }